module.exports = __webpack_public_path__ + "media/images/icons/menu_museum-4e8766dccd035d05550df60630eeffe6.svg";